export const inspectionTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Inspection toiture',
  hero_h1: 'Inspection de toiture gratuite à Lévis',
  hero_subtitle: "Rapport détaillé avec photos, recommandations honnêtes, zéro pression de vente. Réservez en 30 secondes.",
  hero_cta: 'Réserver mon inspection gratuite',
  hero_stat_1: 'Gratuit, sans engagement',
  hero_stat_2: 'Rapport sous 48h',
  hero_stat_3: 'Certifié',

  // Pourquoi inspecter
  pourquoi_h2: 'Pourquoi faire inspecter votre toiture à Lévis',
  pourquoi_1_title: 'PRÉVENIR',
  pourquoi_1_desc: "Détecter un petit problème avant qu'il devienne un dégât majeur. Économie potentielle : des milliers de dollars.",
  pourquoi_2_title: 'VENDRE OU ACHETER',
  pourquoi_2_desc: "Rapport officiel essentiel pour transactions immobilières. Rassure acheteurs et notaires.",
  pourquoi_3_title: 'ASSURANCE',
  pourquoi_3_desc: "Plusieurs assureurs demandent une inspection après 15–20 ans. On fournit le rapport accepté.",

  // Ce qu'on inspecte
  inspecte_h2: "Ce qu'on vérifie pendant l'inspection",
  inspecte_1: 'État général des bardeaux ou membrane',
  inspecte_2: 'Solins métal autour cheminées et évents',
  inspecte_3: 'Ventilation entretoit et soffites',
  inspecte_4: 'Gouttières et descentes pluviales',
  inspecte_5: 'Affaissements ou déformations structure',
  inspecte_6: "Signes d'infiltration à l'intérieur (entretoit)",
  inspecte_7: 'Estimation durée de vie restante',
  inspecte_8: 'Recommandations prioritaires chiffrées',

  // Process
  process_h2: 'Comment se déroule votre inspection',
  process_1_title: 'Vous réservez',
  process_1_desc: 'En ligne ou par téléphone en 30 secondes.',
  process_2_title: 'On planifie',
  process_2_desc: 'Visite dans les 48h ouvrables.',
  process_3_title: 'Inspection sur place',
  process_3_desc: '45–60 minutes, toit et intérieur.',
  process_4_title: 'Rapport envoyé',
  process_4_desc: 'Par courriel sous 48h.',

  // Rapport exemple
  rapport_h2: "Le rapport d'inspection que vous recevez",
  rapport_desc: "Un document professionnel de 5 à 8 pages avec photos annotées, état de chaque section, recommandations classées par priorité (urgent / 1 an / 3–5 ans), et estimation budgétaire si réparation requise. Format PDF acceptable par assureurs et notaires.",
  rapport_cta: "Voir un exemple de rapport",

  // Quand inspecter
  quand_h2: "Quand est-il temps d'inspecter votre toiture ?",
  quand_1: 'Toiture installée il y a 15 ans ou plus',
  quand_2: "Après un événement météo majeur (vent fort, grêle, tempête verglas)",
  quand_3: 'Avant de vendre ou acheter une maison',
  quand_4: "Tache d'humidité apparue au plafond",
  quand_5: 'Demande de votre assureur',
  quand_6: 'Doute, par précaution simple',

  // Témoignage
  temoignage_quote: "On avait un doute sur la toiture de la maison qu'on voulait acheter. L'inspection a révélé un problème caché au niveau des solins que personne n'avait vu. Le rapport détaillé nous a permis de négocier 4 500 $ de rabais avec le vendeur. Un service vraiment honnête, sans pression — je recommande à 100 %.",
  temoignage_author: 'Caroline B.',
  temoignage_city: 'Charny',
  temoignage_detail: 'Inspection avant achat, octobre 2025',

  // FAQ
  faq_h2: "Questions fréquentes sur l'inspection",
  faq_q1: "Pourquoi l'inspection est-elle gratuite ?",
  faq_a1: "L'inspection est gratuite parce qu'on croit que chaque propriétaire mérite de connaître l'état de sa toiture sans barrière financière. C'est aussi notre façon de vous faire découvrir notre travail de qualité. Si une réparation s'avère nécessaire, vous aurez déjà confiance en nous. Si tout va bien, vous aurez la tranquillité d'esprit. C'est gagnant-gagnant.",
  faq_q2: 'Êtes-vous obligé de me vendre une réparation ensuite ?',
  faq_a2: "Absolument pas. L'inspection est sans engagement total. On vous présente les faits, le rapport est à vous. Si vous voulez qu'on fasse les travaux, tant mieux. Si vous préférez attendre ou faire ailleurs, c'est votre choix. On ne fait pas de pression — c'est notre promesse.",
  faq_q3: "Combien de temps prend une inspection ?",
  faq_a3: "L'inspection sur place dure entre 45 et 60 minutes selon la taille et la complexité de votre toiture. On inspecte l'extérieur (bardeaux, solins, gouttières, ventilation) et, si possible, l'intérieur du entretoit pour détecter les infiltration. Le rapport détaillé vous est envoyé par courriel sous 48h après la visite.",
  faq_q4: 'Le rapport est-il accepté par les assureurs ?',
  faq_a4: "Oui, notre rapport est rédigé au format professionnel reconnu par la plupart des assureurs québécois. Il inclut des photos annotées, une évaluation de l'état de chaque composante, et des recommandations priorisées. Plusieurs clients l'ont utilisé pour satisfaire les demandes de leur assureur. Si besoin, on peut aussi fournir un document complémentaire sur demande.",
  faq_q5: "Faut-il être présent pendant l'inspection ?",
  faq_a5: "C'est préférable mais pas obligatoire. Si vous êtes là, on peut vous expliquer en direct ce qu'on observe et répondre à vos questions. Si vous n'êtes pas disponible, on inspecte quand même et on vous envoie le rapport par courriel. On peut aussi faire un suivi téléphonique pour discuter des résultats.",

  // CTA Final
  cta_h2: 'Votre inspection gratuite à Lévis, réservée en 30 secondes',
  cta_subtitle: 'Rapport pro, recommandations honnêtes, zéro engagement.',
  cta_button: 'Réserver mon inspection',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Réserver votre inspection gratuite',
  form_subtitle: 'Remplissez le formulaire — on vous contacte pour planifier sous 48h.',
  form_success: 'Demande envoyée !',
  form_success_sub: "On vous rappelle dans les 2 prochaines heures ouvrables pour planifier l'inspection. Merci de nous faire confiance.",
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_adresse_label: 'Adresse de la propriété',
  form_adresse_placeholder: 'Votre adresse à Lévis, QC',
  form_motif_label: "Motif de l'inspection",
  form_motif_select: 'Sélectionnez un motif',
  form_motif_preventif: 'Inspection préventive',
  form_motif_achat: 'Avant achat',
  form_motif_vente: 'Avant vente',
  form_motif_assurance: 'Demande assurance',
  form_motif_reparation: "Après événement météo",
  form_motif_autre: 'Autre',
  form_message_label: 'Commentaires (optionnel)',
  form_message_placeholder: 'Décrivez votre situation, vos doutes ou questions...',
  form_char_count: '/500',

  // Header/Footer shared
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_link_snow: 'Déneigement',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default inspectionTranslations;